if ( typeof VariantPicker !== 'function' ) {

	class VariantPicker extends HTMLElement {

		constructor(){

			super();

			this.installmentPaymentType = "installment";
			this.normalPaymentType = "normal";
			this.hiddenVariantSelector = this.querySelectorAll('div[data-subscription]');
      this.isOtsPaymentAvailable = document.querySelector(".ots-payment-type");

			// Automatically select the preselected payment method or fallback to the first available
			const preselectedPaymentMethod = document.querySelector('.cart__payment-method').innerText;
			const selectedRadio = document.querySelector(`input[name="payment-method"][value="${preselectedPaymentMethod}"]`) || document.querySelector('input[name="payment-method"]');
			if (selectedRadio) {
				selectedRadio.checked = true;
			}

			this.querySelectorAll('.purchase_type_options').forEach(option => {
				option.querySelector('input[type="radio"]').addEventListener('change', this.checkVariantSubscriptionHandler.bind(this));
			});

			this.querySelectorAll('.payment-type-unselect').forEach(option => {
				option.classList.add("display-none")
			  });

      this.querySelectorAll('input[name="payment-method"]').forEach(radio => {
        radio.addEventListener('change', () => {
          const selectedPurchaseType = Array.from(this.querySelectorAll('.purchase_type_options'))
            .find(option => option.querySelector('input[type="radio"]').checked);

          if (selectedPurchaseType) {
            const hasSubscriptionPlans = selectedPurchaseType.querySelector('input[type="radio"]').getAttribute('data-has-subscription-plans') !== null;
            this.checkVariantSubscription(hasSubscriptionPlans);
          }
        });
      });

			// Adding selected selling plan to the cart drawer on change of variant
			this.querySelector('.product-variant__container').addEventListener('change', this.setSellingPlanId.bind(this));
      this.querySelectorAll('input[name="payment-method"]').forEach(radio => {
        radio.addEventListener('change', this.cartUpdate.bind(this));
      });
			this.querySelector('.product-payment-type--select').addEventListener('change', () => {
				this.hideNonSubscriptionVariant();
				this.setSellingPlanId();
			});
      if (this.isOtsPaymentAvailable) {
        this.querySelector(
          ".product-ots-payment-type--select"
        ).addEventListener("change", () => {
          this.hideNonSubscriptionVariant("ots");
          this.setSellingPlanId();
        });
      }

			this.hideNonSubscriptionVariant();
			const isReturnsSKU =  document.getElementById("is_returns_sku")?.value || false;
			if (!isReturnsSKU) {
				this.setSellingPlanId();
			}

			this.onReloadingforShipmentAmount();
			this.variantChangeShipmentAmounthandler();
			this.variantChangePaymentType();
			this.querySelectorAll('.subscription-payment-type-selection').forEach((e)=>{
			e.addEventListener('change', () => {
			const subscriptionValue = e.value;
			if(subscriptionValue=="subscription"){
				this.onReloadingforShipmentAmount();
			}
			});
			})
    }

		onClearSubscriptionDetails() {
			const spanElement = document.querySelector('.sub_details');
			const deliveryPolicyIntervalElement = this.querySelector('.delivery-policy-interval');
			const deliveryPolicyIntervalCountElement = this.querySelector('.delivery-policy-interval-count');
			if (deliveryPolicyIntervalElement) {
				deliveryPolicyIntervalElement.value = "";
			}
			if (deliveryPolicyIntervalCountElement) {
				deliveryPolicyIntervalCountElement.value = "";
			}
			if (spanElement) {
				spanElement.innerHTML = "";
			}
		}

		retrieveDeliveryPolicyByVariantId() {
			const variantId = this.querySelector('.variant-with-selling-plan-allocation')?.value;
			if(!variantId) {
				this.onClearSubscriptionDetails();
				return;
			}
			const apiUrl = KROWN.settings.subscription_api.get_selling_plan_info_by_variant_id
			const spanElement = document.querySelector('.sub_details');
			const mappedIntervalToLocale = {
				"day": KROWN.settings.locales.days,
				"week": KROWN.settings.locales.weeks,
				"month": KROWN.settings.locales.months,
				"year": KROWN.settings.locales.years
			};
			fetch(`${jpapp.proxyUrl}${apiUrl}?variantId=${variantId}`, {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					Accept: "application/javascript",
				},
			})
			.then((response) => response.json()).then((sellingPlanInfo) => {
				const { sellingPlan: { deliveryPolicy, originalIntervalCount, sellingPlanType  }, error } = sellingPlanInfo;
				const isInstallment = sellingPlanType === "installment";
				if (error) {
					throw new Error("Error fetching selling plan info");
				}
				const deliveryPolicyIntervalElement = this.querySelector('.delivery-policy-interval');
				const deliveryPolicyIntervalCountElement = this.querySelector('.delivery-policy-interval-count');
				if (deliveryPolicyIntervalElement) {
					deliveryPolicyIntervalElement.value = deliveryPolicy.interval;
				}
				if (deliveryPolicyIntervalCountElement) {
					deliveryPolicyIntervalCountElement.value = isInstallment ? originalIntervalCount : deliveryPolicy.intervalCount;
				}
				const localizedString = KROWN.settings.locales.subscription_details;
				const updatedString = localizedString
					.replace('{{ interval }}', mappedIntervalToLocale[deliveryPolicy.interval.toLowerCase()] )
					.replace('{{ intervalCount }}', deliveryPolicy.intervalCount);
				if (spanElement) {
					spanElement.innerHTML = updatedString;
				}
			}).catch((e) => {
				console.log(e);
				this.onClearSubscriptionDetails();
			});
		}

		//this function is called on page load and everytime the user changes the purchase type radio buttons
		hideNonSubscriptionVariant(isOTS) {
      if (isOTS) {
        this.querySelector(".one-time-shipment-radio").click();
      } else {
        this.querySelector('input[data-has-subscription-plans]').click();
			}
			let variantOptionsForPurchase = 0, installmentOptionCount = 0, normalOptionCount = 0;
			const dropdownContainerOptions = this.querySelectorAll('.product-variant-dropdown-value');
			const paymentTypeDropdown = this.querySelector('.product-payment-type--select');
      const paymentOtsTypeDropdown = this.querySelector(".product-ots-payment-type--select");

			// emptying the value of the span which shows the variant if there is only one available
			this.querySelector('.selected_subscription_option').innerHTML = "";

			// looping through the select element for removing display-none initially
			dropdownContainerOptions.forEach(item => {
				item.classList.remove('display-none'); 
				item.disabled = false;
			});
			this.querySelectorAll('.product-payment-type--select option').forEach(opt => opt.classList.remove('display-none'));
      if (this.isOtsPaymentAvailable) {
        this.querySelectorAll(
          ".product-ots-payment-type--select option"
        ).forEach((opt) => opt.classList.remove("display-none")); //ots
      }
			this.querySelector('.product-variant-container-box').classList.remove('display-none');
			
			// count for the amount of variants
			this.hiddenVariantSelector.forEach(element => {
				if (element.getAttribute('data-subscription') !== "") variantOptionsForPurchase++;
				if (element.getAttribute('data-payment-type') !== "") {
					element.getAttribute('data-payment-type') === this.normalPaymentType ? normalOptionCount++ : installmentOptionCount++;
				}
				if (element.hasAttribute("data-linked_sku-available") && element.dataset.linked_skuAvailable !== "") {
					this.querySelector(`.product-variant-dropdown-value[value="${element.dataset.variantName}"]`).setAttribute("data-linked_sku-available",element.dataset.linked_skuAvailable);
				}
			})

			if (normalOptionCount === 0 || installmentOptionCount === 0) {
				const optionPaymentType = normalOptionCount === 0 ? this.installmentPaymentType : this.normalPaymentType;
				this.querySelector(`.product-payment-type--select option[data-payment-type="${optionPaymentType}"]`).classList.add("display-none");
				paymentTypeDropdown.value = this.querySelector('.product-payment-type--select option:not(.display-none)').value;
				//ots
				if (this.isOtsPaymentAvailable) {
					this.querySelector(
						`.product-ots-payment-type--select option[data-payment-type="${optionPaymentType}"]`
					).classList.add("display-none");
					paymentOtsTypeDropdown.value = this.querySelector(
						".product-ots-payment-type--select option:not(.display-none)"
					).value;
				}
			}

      const newPaymentTypeVar = !isOTS
        ? paymentTypeDropdown.value
        : paymentOtsTypeDropdown?.value;
      const paymentTypeValue =
        newPaymentTypeVar !== "" &&
        (newPaymentTypeVar ===
          KROWN.settings.locales.products_payment_type_shipment ||
          newPaymentTypeVar === "Pay in full")
          ? this.normalPaymentType
          : this.installmentPaymentType;

			if (variantOptionsForPurchase >= 1) {

				this.hiddenVariantSelector.forEach(element => {
					if (element.dataset.paymentType === "" || element.dataset.paymentType !== paymentTypeValue) {
						const variantOption = this.querySelector(`.product-variant-dropdown-value[value="${element.dataset.variantName}"]`);
						if (variantOption) {
							variantOption.classList.add("display-none");
							variantOption.disabled = true;
						}
					};
				})
				
				// Get the currently selected value
				const currentSelectedValue = this.querySelector('.product-variant-select').value;

				// Check if the current selected value is a visible option
				const isCurrentValueValid = !!this.querySelector(`.product-variant-select option[value="${currentSelectedValue}"]:not(.display-none)`);

				// If the current selected value is not valid, set it to the first visible option
				if (!isCurrentValueValid) {
					this.querySelector('.product-variant-select').value = this.querySelector('.product-variant-select option:not(.display-none)').value;
				}

				// only per shipment case
				if (variantOptionsForPurchase === 1 || (normalOptionCount === 1 && paymentTypeDropdown.value === KROWN.settings.locales.products_payment_type_shipment) || (installmentOptionCount === 1 && paymentTypeDropdown.value === KROWN.settings.locales.products_payment_type_installment)) {				
					this.querySelector('.product-variant-container-box').classList.add('display-none');
					this.querySelector('.selected_subscription_option').innerHTML = this.querySelector('.product-variant-select').value;
				}
			}
			else {
				const oneTimeShipmentRadio = this.querySelector('.one-time-shipment-radio');
				if (oneTimeShipmentRadio) {
					oneTimeShipmentRadio.click();
					oneTimeShipmentRadio.classList.add('display-none');
				}
        // ots
        if (
          variantOptionsForPurchase === 1 ||
          (normalOptionCount === 1 &&
            paymentTypeDropdown.value ===
              KROWN.settings.locales.products_payment_type_shipment) ||
          (installmentOptionCount === 1 &&
            paymentTypeDropdown.value ===
              KROWN.settings.locales.products_payment_type_installment)
        ) {
          this.querySelector(".product-variant-container-box").classList.add(
            "display-none"
          );
          this.querySelector(".selected_subscription_option").innerHTML =
            this.querySelector(".product-variant-select").value;
        }
				this.querySelector('.subscription_option').classList.add('display-none');
			}
		}

		checkVariantSubscriptionHandler(event) {
			this.checkVariantSubscription(event.target.hasAttribute('data-has-subscription-plans'));
		}

    checkVariantSubscription(hasSubscriptionPlans) {
	  const isReturnsSKU = document.getElementById("is_returns_sku")?.value || false;
      const selectedPaymentMethod = this.querySelector('input[name="payment-method"]:checked');
      const subscriptionOnlyPaymentMethods = this.querySelectorAll('[data-disabled-for-subscription=true]');

      if (hasSubscriptionPlans && !isReturnsSKU) {
        let shouldResetPaymentOption = false;

        subscriptionOnlyPaymentMethods.forEach(option => {
          if (option === selectedPaymentMethod) {
            shouldResetPaymentOption = true;
            option.checked = false;
          }
          // Hide and disable the option
          option.closest('.payment-method__option').classList.add('display-none');
          option.disabled = true;
        });

        if (shouldResetPaymentOption) {
          const firstAvailableOption = this.querySelector('input[name="payment-method"]:not([data-disabled-for-subscription=true])');
          if (firstAvailableOption) {
            firstAvailableOption.checked = true;
          }
        }

        this.querySelector('.subscription-payment-type').classList.remove('display-none');
        if (this.isOtsPaymentAvailable) {
          this.querySelector(".ots-payment-type").classList.add("display-none"); //ots
        }
        this.hideNonSubscriptionVariant();
        this.setSellingPlanId();
        // this.retrieveDeliveryPolicyByVariantId();
      } else if (isReturnsSKU) {
        this.querySelector(".subscription-payment-type").classList.add("display-none");
        this.querySelector(".ots-payment-type").classList.add("display-none");
      } else {
        // Unhide and enable the options
        subscriptionOnlyPaymentMethods.forEach(option => {
          option.closest('.payment-method__option').classList.remove('display-none');
          option.disabled = false;
        });

        this.closest('.product-text').querySelector('#subscription_type').value = "";
        this.closest('.product-text').querySelector('#selling_plan_selection').value = "";
        this.querySelector('.selected_subscription_option').innerHTML = "";
        this.closest('.product-text').querySelector('#selling_plan_properties').value = "";
        this.querySelector('.product-variant-container-box').classList.remove('display-none');
        this.closest('.product-text').querySelector('#selling_plan_name').value = "";

        this.querySelector('.subscription-payment-type').classList.add('display-none');
        this.querySelectorAll('.product-variant-dropdown-value').forEach(item => {
          item.classList.remove('display-none');
          item.disabled = false;
        });

        if (this.isOtsPaymentAvailable) {
          this.querySelector(".ots-payment-type").classList.remove("display-none"); //ots
          this.hideNonSubscriptionVariant("ots"); //ots
          this.setSellingPlanId(); //ots
        }
        this.onClearSubscriptionDetails();
        this.hiddenVariantSelector.forEach(element => {
          if (element.dataset.paymentType === this.installmentPaymentType || element.dataset.oneTimeShipmentDisabled === "true") {
            const variantOption = this.querySelector(`.product-variant-dropdown-value[value="${element.dataset.variantName}"]`);
            if (variantOption) {
              variantOption.classList.add('display-none');
              variantOption.disabled = true;
            }
          }
        });

		if (this.querySelector('.product-variant-select')) {
			// Get the currently selected value
			const currentSelectedValue = this.querySelector('.product-variant-select').value;

			// Check if the current selected value is a visible option
			const isCurrentValueValid = !!this.querySelector(`.product-variant-select option[value="${currentSelectedValue}"]:not(.display-none)`);

			// If the current selected value is not valid, set it to the first visible option
			if (!isCurrentValueValid) {
				this.querySelector('.product-variant-select').value = this.querySelector('.product-variant-select option:not(.display-none)').value;
			}
		}
      }
    }

		setSellingPlanId() {
			const selectedSubscriptionRadioValue = this.querySelector('input[type="radio"]:checked').value;
      const selectedOtsSelectValue =
        this.isOtsPaymentAvailable &&
        this.querySelector(".product-ots-payment-type--select option:checked")
          .value; //ots
			this.closest('.product-text').querySelector('#subscription_type').value = "";
			this.closest('.product-text').querySelector('#selling_plan_selection').value = "";
			const variantDropdownGet = this.querySelector('.product-variant__container');
      const isOtsInstallment = selectedSubscriptionRadioValue === "one-time" && selectedOtsSelectValue === "Installments";
      const isOtsPayInFull =  selectedSubscriptionRadioValue === "one-time" && selectedOtsSelectValue === "Pay in full";
      const subscriptionOnlyPaymentMethods = this.querySelectorAll("[data-disabled-for-subscription=true]");
	  //Enabling only subscription payment methods for OTS installment contracts
      if (isOtsInstallment) {
        const selectedPaymentMethod = this.querySelector('input[name="payment-method"]:checked');
        subscriptionOnlyPaymentMethods.forEach((option) => {
          if (option === selectedPaymentMethod) {
            shouldResetPaymentOption = true;
            option.checked = false;
          }
          // Hide and disable the option
          option.closest(".payment-method__option").classList.add("display-none");
          option.disabled = true;
        });
      }
	  //Enabling all the payment methods for OTS pay in full
      if (isOtsPayInFull) {
        subscriptionOnlyPaymentMethods.forEach((option) => {
          option.closest(".payment-method__option").classList.remove("display-none");
          option.disabled = false;
        });
      }
			this.hiddenVariantSelector.forEach(element => {
				if (
					element.getAttribute('data-variant-name') === variantDropdownGet.value &&
					element.getAttribute('data-subscription') !== "" &&
					(selectedSubscriptionRadioValue === "subscription" || isOtsInstallment)
				) {
          const subscriptionName = element.getAttribute("data-subscription-name");
          this.closest(".product-text").querySelector("#selling_plan_name").value = isOtsInstallment ? KROWN.settings.ots.ots_selling_plan_name : subscriptionName;
					this.closest('.product-text').querySelector('#subscription_type').value = element.getAttribute('data-payment-type');
					this.closest('.product-text').querySelector('#selling_plan_selection').value = element.getAttribute('data-subscription');
          this.closest(".product-text").querySelector(
            "#ots_payment_selection"
          ).value = isOtsInstallment ? "OTS-Installment" : "";
          this.closest(".product-text").querySelector(
            "#ots_payment_selection_properties"
          ).value = isOtsInstallment;
				}
			});
		}
		
		/** update span element with change in variant shipment amount */
		variantChangeShipmentAmounthandler (){
			const shipmentAmountBox = document.querySelector('.product-variant-shipment-amount');
			shipmentAmountBox.addEventListener('change', () => {
				const selectedText = shipmentAmountBox.value.trim();

				const selectedVariant = [...document.querySelectorAll(".hidden-variant-dropdown div")].find(
					(div) => div.innerHTML.trim() == selectedText
				);
				if(selectedVariant){
					const variantId = selectedVariant.getAttribute("Value");
					this.onChangeVariantforShipmentAmount(variantId);
				}
				});
		}

		/** update span element with change in payment type option */
		variantChangePaymentType(){
			const paymentTypeBox = document.querySelector('.product-variant-payment-type-select');
			paymentTypeBox.addEventListener('change', () => {
				const selectedOption = paymentTypeBox.options[paymentTypeBox.selectedIndex];
				const selectedPaymentType = selectedOption.getAttribute("data-payment-type")?.trim()
				if(selectedPaymentType=="installment"){
					const selectedVariant = [...document.querySelectorAll(".hidden-variant-dropdown div")].find(
					(div) => div.getAttribute("data-payment-type").trim() == selectedPaymentType
					);

				if(selectedVariant){
					const variantId = selectedVariant.getAttribute("Value");
					this.onChangeVariantforShipmentAmount(variantId, true);
				}  
				} else {
					this.onReloadingforShipmentAmount();
				}
				});
		}

		/** update span element during page reloading */
		onReloadingforShipmentAmount(){
			const paymentTypeBox = document.querySelector('.product-variant-payment-type-select');
			const selectedOption = paymentTypeBox.options[paymentTypeBox.selectedIndex];
			const selectedPaymentType = selectedOption.getAttribute("data-payment-type")?.trim()
			if(selectedPaymentType=="installment"){
			const selectedVariant = [...document.querySelectorAll(".hidden-variant-dropdown div")].find(
					  (div) => div.getAttribute("data-payment-type").trim() == selectedPaymentType
					);
					if(selectedVariant){
					  	const variantId = selectedVariant.getAttribute("Value");
						this.onChangeVariantforShipmentAmount(variantId, true);
					}  
			  
			} else {
			 const shipmentAmountBox = document.querySelector('.product-variant-shipment-amount');
			 const selectedText = shipmentAmountBox.value.trim();
			 const selectedVariant = [...document.querySelectorAll(".hidden-variant-dropdown div")].find(
					  (div) => div.innerHTML.trim() == selectedText
					);
					if(selectedVariant){
						const variantId = selectedVariant.getAttribute("Value");
						this.onChangeVariantforShipmentAmount(variantId);
					}
			}
			
		}

		/** fetch api endpoint to update span element
		 * sellingPlan info
		 */
		onChangeVariantforShipmentAmount(variantId, isInstallmentSection=false) {
			if(!variantId) {
				this.onClearSubscriptionDetails();
				return;
			} 
			const apiUrl = KROWN.settings.subscription_api.get_selling_plan_info_by_variant_id
			const spanElement = document.querySelector('.sub_details');
			const mappedIntervalToLocale = {
				"day": KROWN.settings.locales.days,
				"week": KROWN.settings.locales.weeks,
				"month": KROWN.settings.locales.months,
				"year": KROWN.settings.locales.years
			};
			fetch(`${jpapp.proxyUrl}${apiUrl}?variantId=${variantId}`, {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					Accept: "application/javascript",
				},
			})
			.then((response) => response.json()).then((sellingPlanInfo) => {
				const { sellingPlan: { deliveryPolicy, originalIntervalCount, sellingPlanType  }, error } = sellingPlanInfo;
				const isInstallment = sellingPlanType === "installment";
				if (error) {
					console.log("unable to fetch selling plan info from getSellingPlanInfoByVariantId", error)
					return;
				}
				
				const deliveryPolicyIntervalElement = this.querySelector('.delivery-policy-interval');
				const deliveryPolicyIntervalCountElement = this.querySelector('.delivery-policy-interval-count');
				if (deliveryPolicyIntervalElement) {
					deliveryPolicyIntervalElement.value = deliveryPolicy.interval;
				}
				if (deliveryPolicyIntervalCountElement) {
					deliveryPolicyIntervalCountElement.value = isInstallment ? originalIntervalCount : deliveryPolicy.intervalCount;
				}
				const localizedString = KROWN.settings.locales.subscription_details;
				const updatedString = localizedString
					.replace('{{ interval }}', mappedIntervalToLocale[deliveryPolicy.interval.toLowerCase()])
					.replace('{{ intervalCount }}', isInstallmentSection ? originalIntervalCount : deliveryPolicy.intervalCount);
				
				if (spanElement) {
					spanElement.innerHTML = updatedString;
				}
			}).catch((e) => {
				console.log(e);
				this.onClearSubscriptionDetails();
			});
		}


		// function to call confirmation modal of changing payment method
    cartUpdate() {
      const currentPaymentMethodTypeInCart = document.querySelector(".cart__payment-method").innerHTML;
      const paymentMethodSelected = document.querySelector('input[name="payment-method"]:checked')?.value;
      if (currentPaymentMethodTypeInCart && currentPaymentMethodTypeInCart !== paymentMethodSelected) {
        document.getElementById("gocardlessModal").show();
      }
    }
	}

	// changing the payment method to the previously selected one on click of No button in modal
	document.querySelector(".cta-no").addEventListener("click", () => {
		handleCloseAction();
	});

	// changing the payment method to the previously selected one on closing the modal
	document.querySelector("#gocardlessModal .modal-close").addEventListener("click", () => {
		handleCloseAction();
	});

	// calling clear cart api on click of yes in payment method reset in modal
	document.querySelector(".cta-yes").addEventListener("click", () => {
		document.querySelector(".cta-no").classList.add('no-click');
		document.querySelector(".cta-yes").classList.add('no-click');
		document.querySelector(".cta-yes .button-text").classList.add('visibility-hidden');
		document.querySelector(".cta-yes .button-loader-container").classList.remove('visibility-hidden');

		fetch(KROWN.settings.routes.cart_clear_url, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Accept: "application/javascript",
			},
		})
		.then((response) => response.json())
		.then(() => {
			return fetch("?section_id=helper-cart");
		})
		.then((response) => response.text())
		.then((text) => {
			const sectionInnerHTML = new DOMParser().parseFromString(text,"text/html");
			const cartFormInnerHTML = sectionInnerHTML.getElementById("AjaxCartForm").innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById("AjaxCartSubtotal").innerHTML;

			const cartItems = document.getElementById("AjaxCartForm");
			cartItems.innerHTML = cartFormInnerHTML;
			cartItems.ajaxifyCartItems();

			document.querySelectorAll("[data-header-cart-count]").forEach((elm) => {
				elm.textContent = cartItems.querySelector("[data-cart-count]").textContent;
			});
			document.querySelectorAll("[data-header-cart-total]").forEach((elm) => {
				elm.textContent = cartItems.querySelector("[data-cart-total]").textContent;
			});

			if (alert !== null) {
				this.form?.prepend(alert);
			}

			document.getElementById("AjaxCartSubtotal").innerHTML = cartSubtotalInnerHTML;

			const event = new Event("cart-updated");
			this.dispatchEvent(event);
		})
		.then(() => {
			const paymentMethodType = document.querySelector(".cart__payment-method").innerHTML;
			const isManualPayment = KROWN.settings.manualPaymentTypes.includes(paymentMethodType);
			if (isManualPayment) {
				const sellingPlanProp = document.querySelector('#selling_plan_properties');
				if (sellingPlanProp.value) {
					document.querySelector('#selling_plan_selection').value = sellingPlanProp.value;
					sellingPlanProp.value = ""; 
				}  
			}

			document.getElementById("gocardlessModal").hide();

			document.querySelector(".cta-no").classList.remove('no-click');
			document.querySelector(".cta-yes").classList.remove('no-click');
			document.querySelector(".cta-yes .button-text").classList.remove('visibility-hidden');
			document.querySelector(".cta-yes .button-loader-container").classList.add('visibility-hidden');
		})
		.catch((e) => {
			console.log(e);
		});
	});

	// changing the payment method to the previously selected one
  handleCloseAction = () => {
    const paymentMethodType = document.querySelector(".cart__payment-method").innerHTML;
    const selectedRadio = document.querySelector(`input[name="payment-method"][value="${paymentMethodType}"]`) || document.querySelector(`input[name="payment-method"]`);

    if (selectedRadio) {
      selectedRadio.checked = true;
    }
  }

	if ( typeof customElements.get('variant-picker') == 'undefined' ) {
		customElements.define('variant-picker', VariantPicker);
	}

}